@if (commentSignal() | hasReactions) {
  <div class="reactions flex gap-quarter">
    @if (commentSignal() | getReactionTags$ | async; as reactionTags) {
      @for (reactionTag of reactionTags; track reactionTag.reaction) {
        <div
          [loopHoverTooltip]="(reactionTag.reactionUserNames | join) + ' reacted with ' + reactionTag.reaction"
          class="reaction"
          [class.my-reaction]="reactionTag.isMyReaction"
          (click)="toggleReaction(reactionTag.reaction)"
        >
          {{ reactionTag.reaction }}
          <span>{{ reactionTag.reactionCount }}</span>
        </div>
      }
    }
  </div>
}
